import React from 'react'
import {HeroSection} from './HeroSection/HeroSection'
import {OverviewSection} from './OverviewSection/OverviewSection'
import {ServicesSection} from './ServicesSection/ServicesSection'
import {Industries} from './Industries/Industries'
import {IndustriesServe} from './IndustriesServe/IndustriesServe'
import {ProductsSection} from './ProductSection/ProductsSection'
import {GlobalPresenceMap} from "./GlobalPresence/GlobalPresenceMap"

function Layout() {
  return (
    <div>
          <HeroSection></HeroSection>
          <OverviewSection></OverviewSection>
          <Industries></Industries>
          {/* <GlobalPresenceMap></GlobalPresenceMap> */}
          {/* <ProductsSection></ProductsSection> */}
    </div>
  )
}

export default Layout